import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styles from '../Filters.module.scss';

import {
  FindSelectedElement,
  GetLastLevelName,
  GetPlanId,
  GetSelectCountries,
  GetSelectElements
} from '../../../../helpers/Helpers';

// import SingleSelectSidebar from '../../single-select-sidebar/SingleSelectSidebar';
import MultiSelectSidebar from '../../multi-select-sidebar/MultiSelectSidebar';
import SingleSelectRadioSidebar from '../../single-select-radio-sidebar/SingleSelectRadioSidebar';

import {
  GetProductHierarchyList,
  UpdateProductHierarchyList
} from '../../../../api-services/filters.api';

import { UpdateFilterData } from '../../../../store/filter-data/actions';
import PageLoader from '../../loader/PageLoader';

interface OwnProps {
  selection: string;
  history?: any;
  selectedData: any;
  selectedLocationData: any;
  updateSelection: (status) => void;
}

interface StateProps {
}

interface DispatchProps {
  UpdateFilterData: (data) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  showSidebar: boolean;
  maxLevel: number;
  productList: any[];
  selectedProductList: any[];
  isSaved: boolean;
  isLoading: boolean;
}

class ProductFilter extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showSidebar: false,
      maxLevel: 0,
      productList: [],
      selectedProductList: !!this.props.selectedData ? this.props.selectedData.levels : [],
      isSaved: !!this.props.selectedData,
      isLoading: false
    };
  }

  componentDidMount(): void {
    this.updateFilterInfo(this.state.selectedProductList);
  }

  getProductHierarchyList(dataSource?): void {
    const payload = {
      dimensionName: 'Product',
      maxLevel: this.state.maxLevel,
      levels: dataSource
    };
    this.setState({
      isLoading: true
    });
    const params = {
      userId: sessionStorage.getItem('userName')
    };

    if (!!this.props.selectedLocationData) {
      const dataSource = FindSelectedElement(this.props.selectedLocationData.levels, ({ selected }) => selected);
      const selectedLocation: string[] = GetSelectCountries(dataSource);

      if (selectedLocation.length > 0) {
        params['countries'] = selectedLocation[0];
        params['locLevel'] = selectedLocation[1];
      }
    }

    const apiCall = dataSource === undefined ? GetProductHierarchyList(params) : GetProductHierarchyList(params, payload);

    apiCall
      .then((res: {
        maxLevel: number;
        levels: any[]
      }) => {
        if (!!res) {
          this.setState({
            maxLevel: res.maxLevel,
            productList: res.levels,
            showSidebar: true,
            isLoading: false
          });
        }
      });
  }

  updateProductHierarchyList(dataSource): void {
    const payload = {
      dimensionName: 'Product',
      maxLevel: this.state.maxLevel,
      levels: dataSource
    };

    const params = {
      planId: GetPlanId(this.props.history.location.pathname)
    };

    UpdateProductHierarchyList(payload, params)
      .then((res) => {
        if (!!res) {
          this.props.updateSelection(true);
          this.setState({
            showSidebar: false,
            isSaved: true,
            selectedProductList: dataSource
          }, () => {
            this.updateFilterInfo(dataSource);
          });
        }
      });
  }

  updateFilterInfo(dataSource): void {
    const selectedElement = FindSelectedElement(dataSource, ({ selected }) => selected);
    const selectedProducts: string[] = GetSelectElements(selectedElement, 'product');

    this.props.UpdateFilterData({
      products: selectedProducts.join(', '),
      level: GetLastLevelName(selectedElement)[0]
    });
  }

  displaySelectedItem(): any {
    const dataSource = FindSelectedElement(this.state.selectedProductList, ({ selected }) => selected);
    if (dataSource.length === 0 || !this.state.isSaved) {
      return <span>N/A</span>;
    }

    const selectedProducts: string[] = GetSelectElements(dataSource, 'product');
    return <span>{selectedProducts.join(', ')}</span>;
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <PageLoader
          status={this.state.isLoading}
          fromFilter={true}
        />
        <p
          className={styles['filter-label']}
          onClick={() => this.props.selectedLocationData.levels.length > 0 && this.getProductHierarchyList()}
        >
          Product Hierarchy
        </p>
        <p className={styles['filter-value']}>
          {this.displaySelectedItem()}
        </p>

        {
          this.state.showSidebar && (
            this.props.selection === 'single'
              ? <SingleSelectRadioSidebar
                title="Product"
                dataSource={this.state.productList}
                lastLevel={this.state.maxLevel}
                onHideSidebar={() => this.setState({ showSidebar: false })}
                onNext={(dataSource) => this.getProductHierarchyList(dataSource)}
                onSave={(data) => {
                  this.updateProductHierarchyList(data);
                  this.props.updateSelection(true); // This triggers parent to reload grids
                }}
                isProductFilter={true} // Indicating this is a product filter
              />
              : <MultiSelectSidebar
                title="Product"
                dataSource={this.state.productList}
                lastLevel={this.state.maxLevel}
                onHideSidebar={() => this.setState({ showSidebar: false })}
                onNext={(dataSource) => this.getProductHierarchyList(dataSource)}
                onSave={(data) => this.updateProductHierarchyList(data)}
              />
          )
        }
      </React.Fragment>
    );
  }
}

export default connect<StateProps, DispatchProps, OwnProps>
(null, {
  UpdateFilterData
})(withRouter(ProductFilter));
